import * as angular from "angular";

angular
  .module('bringoz.admin.sites', [
    'bringoz.admin.commons'
  ]);
